
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"44","height":"44"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 8488","fill":"none"}},[_c('path',{attrs:{"data-name":"Rectangle 4208","d":"M0 0h44v44H0z"}}),_c('g',{attrs:{"data-name":"Group 5930","stroke":"#109a50","stroke-linecap":"round"}},[_c('path',{attrs:{"data-name":"Path 7792","d":"M37.592 16.488a3.174 3.174 0 01-6.318 0 3.174 3.174 0 01-6.318 0 3.174 3.174 0 01-6.318 0 3.174 3.174 0 01-6.318 0 3.174 3.174 0 01-6.318 0","stroke-linejoin":"round"}}),_c('path',{attrs:{"data-name":"Path 7793","d":"M6 16.488L9.293 6.041A1.435 1.435 0 0110.673 5H32.92a1.435 1.435 0 011.38 1.041l3.293 10.447","stroke-miterlimit":"10"}}),_c('path',{attrs:{"data-name":"Path 7794","d":"M35.438 19.36v17.232a1.437 1.437 0 01-1.436 1.436H9.59a1.437 1.437 0 01-1.436-1.436V19.36","stroke-linejoin":"round"}}),_c('path',{attrs:{"data-name":"Line 100","stroke-miterlimit":"10","d":"M18.206 17.924v20.104"}}),_c('path',{attrs:{"data-name":"Line 101","stroke-miterlimit":"10","d":"M13.898 26.54v1.436"}}),_c('path',{attrs:{"data-name":"Line 102","stroke-miterlimit":"10","d":"M31.274 16.488L29.545 5"}}),_c('path',{attrs:{"data-name":"Line 103","stroke-miterlimit":"10","d":"M24.955 16.488L23.89 5"}}),_c('path',{attrs:{"data-name":"Line 104","stroke-miterlimit":"10","d":"M18.637 16.488L19.612 5"}}),_c('path',{attrs:{"data-name":"Line 105","stroke-miterlimit":"10","d":"M12.318 16.488L14.167 5"}})])])])
          )
        }
      }
    